<template>
    <transition name="modal" data-keyboard="false" data-backdrop="static">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <div class="modal-header align-items-center no-gutters">
                            <div class="col-10">Agregar observacion en {{ nombreEmpresa }}</div>
                            <div class="col-2 text-right">
                                <button type="button" class="btn btn-sm btn-light font-weight-bold" @click.prevent="close()"> x </button>
                            </div>
                        </div>
                        <!-- Success title -->
                        <div class="modal-body" v-if="!success">
                            <label for="listaEmpleados" class="form-label mt-2">Agregar una observación</label>
                            <div class="alert alert-success w-100" v-if="triggers.success">✓ {{triggers.successMessage}}</div>
                            <div class="alert alert-danger w-100" v-if="(!triggers.success) && triggers.dangerMessage!=null">✓ {{triggers.dangerMessage}}</div>                            
                            
                            <div class="alert alert-success w-100" id="hrbp" v-html="observacion"></div>
                            <textarea v-if="isEditor('Empresas')==true" class="w-100 form-control"  @change="errors.observacion = false" rows="3" id="observacion"></textarea>
                            

                            <textarea v-else class="w-100 form-control" v-model="observacion" @change="errors.observacion = false" rows="3" disabled="true"></textarea>
                           

                            <p class="text-danger my-2" v-if="errors.observacion">· Lo observación no puede estar vacia</p>
                            <p class="text-danger my-2" v-if="errors.observacion">· Para eliminarla usá el botón "quitar observacion"</p>
                            <div class="w-100 text-right my-2" v-if="isEditor('Empresas')==true">
                                <!--<button type="button" class="btn btn-danger" @click.prevent="quitarObservacion()">Quitar observación</button>-->
                                <button data-keyboard="false" type="button" class="btn btn-success ml-2" @click.prevent="agregarObservacion()">Agregar observación</button>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </transition>
</template>

<script>
import axios from 'axios';
import firebase from "firebase/app";
import "firebase/database";
const userPermission = JSON.parse(sessionStorage.getItem('userPermisos'));

export default {
    name: "ModalObservar",
    props: ['modalOperacion_fecha','modalOperacion_fireid','modalOperacion_ubicacion'],
    data(){
        return {
            errors: {
                observacion: false 
            },
            triggers: {
                success: false,
                successMessage: null,
                dangerMessage: null,
            },
            observacion: '',
            seObservo: false,
        }
    },
    mounted(){
            this.obtenerObservacion();



            console.log(this.modalOperacion_fecha + " " + this.modalOperacion_fireid+ " " + this.modalOperacion_ubicacion);
        },
    methods: {
         isEditor(modulo){
      
          if (userPermission.find( record => record.ModulosAccess === modulo)) {
            var status =  userPermission.find( record => record.ModulosAccess === modulo).Editor;
            console.log(modulo+' : '+status)
            return status;
          }else{
            console.log(modulo+' : '+false)
            return false;
          }
        },
        obtenerObservacion(){





            this.limpiarTriggers();
            this.observacion = null;
            // Obtener Observacion
            axios
            .get('https://aplicativos.firebaseio.com/operaciones_irregulares/'+ this.modalOperacion_fecha +'/'+this.modalOperacion_fireid+'/'+this.modalOperacion_ubicacion+'.json?print=pretty')
            .then(response => {
                if (response.status == 200) {
                   
                    if(response.data != null){

                        if (response.data.observacion.includes("Gerencia")) {
                             this.observacion =response.data.observacion
                        }else{
                            this.observacion = "<b>HRBP:</b> "+response.data.observacion
                        }

                    }

                   
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        agregarObservacion(){
            this.limpiarTriggers();
            if (this.observacion == '') {
                this.errors.observacion = true;
                return null;
            }else {
                var observacion = $("#observacion").val();
                console.log("chequeo");
                console.log(this.modalOperacion_ubicacion)
                console.log(observacion)
                var hrbp = $("#hrbp").html();
                $('#empresas').DataTable().cell(this.modalOperacion_ubicacion, 12).data(hrbp+'<br><b>Gerencia:</b>'+observacion)
                

                firebase.database().ref('operaciones_irregulares/'+ this.modalOperacion_fecha +'/'+this.modalOperacion_fireid+'/'+this.modalOperacion_ubicacion).update({
                    observacion:hrbp+"<br><b>Gerencia:</b>"+observacion
                }, (error) => {
                    if (error) {
                        alert("Datos no cargados! verifique su conexión a internet")
                    } else {
                        console.log("insertado ok");
                        this.triggers.successMessage = "Observacion realizada correctamente";
                        this.triggers.success = true;
                        this.obtenerObservacion();
                        this.seObservo = true;

                        setTimeout(function(){
                            this.$emit('cerrar-modal-observar');
                        },2000)
                        
                        
                        
                    }
                });
            }
        },
        quitarObservacion(){
            this.limpiarTriggers();
             $('#empresas').DataTable().cell(this.modalOperacion_ubicacion, 12).data('-')
            if(this.observacion != '' && this.observacion != null){
                 firebase.database().ref('operaciones_irregulares/'+ this.modalOperacion_fecha +'/'+this.modalOperacion_fireid+'/'+this.modalOperacion_ubicacion).update({
                    observacion:'-'
                }, (error) => {
                    if (error) {
                        alert("Datos no cargados! verifique su conexión a internet")
                    } else {
                        console.log("insertado ok");
                        this.triggers.successMessage = "Observacion realizada correctamente";
                        this.triggers.success = true;
                        this.obtenerObservacion();
                        this.seObservo = true;
                        
                        
                        
                    }
                });

                this.triggers.successMessage = "Observación eliminada";
                this.observacion = '';
                this.triggers.success = true;
                this.obtenerObservacion();
                this.seObservo = true;
                return true;
            }
            this.triggers.dangerMessage = "No hay nada para eliminar";
        },
        limpiarTriggers(){
            this.success = false;
            this.successMessage = null;
            this.dangerMessage = null;
        },
        close(){
            this.$emit('cerrar-modal-observar');
        },

    }
}
</script>

<style scoped>
h3 {
    color: #1ea21e;
}

.input-error {
    border-color: red;
}

.modal-mask {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
    width: 60%;
    margin: 0px auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 8px #00000016;
    transition: all .3s ease;
    font-size: 16px;

    /* max-height: 800px;
    overflow-y: scroll; */
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-body select {
    margin-bottom: 1rem;
}

input, select {
    font-size: 16px;
}

.modal-default-button {
  float: right;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>